import React from 'react';
import { useData } from '../../context/DataContext';
import { computeGroupStats } from '../../utils/calculations';

export const PrincipalDirectoryTable = ({ onBranchClick }) => {
  const { getScopedStudents } = useData();

  const scoped = getScopedStudents();
  const branches = [...new Set(scoped.map(s => s.school).filter(Boolean))].sort();

  return (
    <div className="bg-white p-6 rounded-2xl shadow-lg border-2 border-gray-100 mb-8 select-none">
      <div className="flex justify-between items-center mb-6">
        <div>
          <h3 className="text-xl font-bold text-gray-800">School Directory</h3>
          <p className="text-sm text-gray-500">
            Select a branch to view the complete 2-page school performance report
          </p>
        </div>
      </div>

      <div className="overflow-x-auto rounded-xl border border-gray-200">
        <table className="w-full text-sm border-collapse">
          <thead className="bg-blue-600 text-white">
            <tr>
              <th className="py-3 px-4 text-left font-bold">School</th>
              <th className="py-3 px-4 text-center font-bold">Students Assessed</th>
              <th className="py-3 px-4 text-center font-bold">Participation %</th>
              <th className="py-3 px-4 text-center font-bold">Overall Avg Score</th>
              <th className="py-3 px-4 text-center font-bold">Action</th>
            </tr>
          </thead>
          <tbody>
            {branches.length === 0 ? (
              <tr>
                <td colSpan="5" className="py-10 text-center text-gray-400 font-bold italic">
                  No school records available.
                </td>
              </tr>
            ) : (
              branches.map((branch) => {
                const branchStudents = scoped.filter(s => s.school === branch);
                const stats = computeGroupStats(branchStudents);
                const partPct = stats.total > 0 ? Math.round((stats.participated / stats.total) * 100) : 0;

                return (
                  <tr key={branch} className="border-b border-gray-100 hover:bg-gray-50 transition-colors">
                    <td className="py-3 px-4 font-bold text-gray-900">{branch}</td>
                    <td className="py-3 px-4 text-center text-gray-700 font-medium">
                      {stats.participated} / {stats.total}
                    </td>
                    <td className="py-3 px-4 text-center font-bold text-green-600">
                      {partPct}%
                    </td>
                    <td className="py-3 px-4 text-center font-bold" style={{ color: '#1e3a5f' }}>
                      {stats.participated > 0 ? Math.round(stats.avgOverall) + '%' : '—'}
                    </td>
                    <td className="py-3 px-4 text-center">
                      <button
                        onClick={() => onBranchClick(branch)}
                        className="bg-blue-50 text-blue-600 px-3 py-1.5 rounded border border-blue-200 hover:bg-blue-100 font-bold text-xs transition-colors cursor-pointer"
                      >
                        View Report
                      </button>
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};
export default PrincipalDirectoryTable;
